<template>
  <div id="homePage">
    <div class="homePage_content" v-show="searchState">
      <div class="homePage_view" v-show="!menuState">
        <div class="home-header">
          <div class="home-tab">
            <div>{{ $t("homePage.purchaseNFT") }}</div>
          </div>
          <!-- 菜单入口 -->
          <div class="allPage-icon" v-if="isNoCodePay">
            <img src="@/assets/images/icons/meun-icon.png" @click="openMenu" />
          </div>
        </div>
        <div class="home-children">
          <fiat-currency-buy-nft ref="NFT_ref" />
        </div>
      </div>
      <!--  menu view  -->
      <div v-show="menuState">
        <div class="navigationBar_view">
          <div class="navigationBar_view_left">{{ $t("menu.menu") }}</div>
          <div
            class="navigationBar_view_right"
            @click="openMenu"
            v-if="isNoCodePay"
          >
            <img
              src="@/assets/images/icons/ShutDown.png"
              style="margin-right: -0.05rem"
            />
          </div>
        </div>
        <routerMenu />
      </div>
    </div>
    <!-- search Public organization -->
    <search
      v-if="!searchState"
      ref="search_ref"
      :viewName="viewName"
      :allBasicData="filter_basicData"
      routerFrom="home"
    />
  </div>
</template>

<script>
import search from "@/components/search";
import routerMenu from "@/components/routerMenu";
import { hashQuery, storeMerchantInfo } from "@/utils/publicRequest";
import FiatCurrencyBuyNft from "@/views/initialPage/childrens/fiatCurrencyBuyNft";
import { mapState } from "vuex";

export default {
  name: "index",
  components: { FiatCurrencyBuyNft, search, routerMenu },
  data() {
    return {
      menuState: false,
      searchState: true,
      viewName: "",
      basicData: {},

      filter_basicData: {},
    };
  },
  computed: {
    ...mapState("buyNftHome", {
      merchantParam: (state) => state.merchantParam,
    }),
    ...mapState("merchantInfo", {
      isNoCodePay: (state) => state.isNoCodePay,
    }),
  },
  mounted() {
    console.log("home data mounted");
  },
  activated() {
    this.queryInfo();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      //登陆后刷新首页基本数据
      if (
        to.name === "home" &&
        ["verifyCode", "emailCode"].includes(from.name)
      ) {
        vm.queryInfo();
      }
    });
  },
  methods: {
    //子组件打开search组件
    openSearch(view) {
      this.searchState = false;
      this.viewName = view;
    },

    //打开菜单
    openMenu() {
      this.menuState = this.menuState ? false : true;
      this.$store.commit("public/set_menuState", this.menuState);
    },

    //获取基本数据 - 国家、法币、加密币、网络
    queryInfo() {
      //对接商户参数 - 语言、tab状态、商户token
      storeMerchantInfo();
      let _this = this;
      //带入商户信息
      let merchantInfo = "";
      if (JSON.stringify(hashQuery().query) !== "{}") {
        merchantInfo = "?" + JSON.parse(JSON.stringify(hashQuery())).fullPath;
      } else {
        merchantInfo = JSON.parse(sessionStorage.getItem("merchantInfo"))
          ? "?" +
            JSON.parse(sessionStorage.getItem("merchantInfo")).merchantParam
          : "";
      }
      this.$axios
        .get(this.$api.get_basicData + merchantInfo, "")
        .then((res) => {
          if (res && res.data) {
            this.$store.commit("buyNftHome/set_usdAmount", res.data.usdAmount);

            //存储首页基本数据
            _this.basicData = JSON.parse(JSON.stringify(res.data));
            if (
              ["sbx", "production", "pre"].includes(process.env.VUE_APP_TITLE)
            ) {
              _this.filter_basicData.fiatCurrencyList = JSON.parse(
                JSON.stringify(res.data),
              ).fiatCurrencyList; //.filter(val=>{return val.code !== 'USD'})
            } else {
              _this.filter_basicData.fiatCurrencyList = JSON.parse(
                JSON.stringify(res.data),
              ).fiatCurrencyList;
            }
            localStorage.setItem(
              "allBasicData",
              JSON.stringify(_this.basicData),
            );
            //商户信息有效存储商户地址栏参数
            let allQuery =
              JSON.stringify(hashQuery().query) !== "{}"
                ? hashQuery().query
                : JSON.parse(sessionStorage.getItem("merchantInfo"));
            let routerParams = {
              merchantParam:
                JSON.stringify(hashQuery().query) !== "{}"
                  ? hashQuery().fullPath
                  : JSON.parse(sessionStorage.getItem("merchantInfo"))
                      .merchantParam,
              appId:
                JSON.stringify(hashQuery().query) !== "{}"
                  ? hashQuery().query.appId
                  : JSON.parse(sessionStorage.getItem("merchantInfo")).appId,
              ...allQuery,
            };
            sessionStorage.setItem(
              "merchantInfo",
              JSON.stringify(routerParams),
            );
            this.$store.commit(
              "buyNftHome/set_merchantParam",
              JSON.parse(JSON.stringify(routerParams)).merchantParam,
            );
            this.$store.commit("merchantInfo/set_merchantInfo", routerParams);
          }
          //初始化NFT组件数据
          this.$nextTick(() => {
            this.$refs.NFT_ref.processingData(this.basicData);
          });
        })
        .catch(() => {
          //初始化NFT组件数据
          this.$nextTick(() => {
            this.$refs.NFT_ref.processingData(this.basicData);
          });
        });
    },
  },
};
</script>

<style lang="scss" src="./css/index.scss" scoped></style>
